import * as React from 'react';
import {
  useNavigationBuilder,
  createNavigatorFactory,
  DefaultNavigatorOptions,
  TabRouter,
  TabRouterOptions,
  TabNavigationState,
  ParamListBase,
  TabActionHelpers,
} from '@react-navigation/native';
import BottomTabView from '../components/BottomTabView';
import type {
  BottomTabNavigationConfig,
  BottomTabNavigationOptions,
  BottomTabNavigationEventMap,
} from '../components/types';

type Props = DefaultNavigatorOptions<
  ParamListBase,
  string | undefined,
  TabNavigationState<ParamListBase>,
  BottomTabNavigationOptions,
  BottomTabNavigationEventMap,
  typeof BottomTabNavigator
> &
  TabRouterOptions &
  BottomTabNavigationConfig;

function BottomTabNavigator({initialRouteName, backBehavior, children, screenOptions, ...rest}: Props) {
  const {state, descriptors, navigation} = useNavigationBuilder<
    TabNavigationState<ParamListBase>,
    TabRouterOptions,
    TabActionHelpers<ParamListBase>,
    BottomTabNavigationOptions,
    BottomTabNavigationEventMap
  >(TabRouter, {
    initialRouteName,
    backBehavior,
    children,
    screenOptions,
  });

  return <BottomTabView {...rest} state={state} navigation={navigation} descriptors={descriptors} />;
}

export default createNavigatorFactory(BottomTabNavigator);
